export const promoScorecardGraphParser = (data: any, config: any) => {
    const { promoScoreCard } = config;
    const labelKeyMapping: any = promoScoreCard.promoTypeLabelMapping;
    const result: any = {
        brand: {
            data: [],
            minVal: 0,
            maxVal: 0,
            label: [],
        },
        promo: {
            label: [],
            data: [],
            minVal: 0,
            maxVal: 0,
        },
        brandList: [],
    };

    try {
        data?.forEach((item: any, idx: number) => {
            //dont add client data to list (idx 0 is clients data)
            if (idx > 0) {
                const tempBrandList = {
                    label: item?.attributeType,
                    value: idx,
                };
                result.brandList.push(tempBrandList);
            }
            result.brand.label.push(item?.attributeType);
            const tempBrandData: any[] = [];
            item?.questionsData?.scoreData?.forEach((scoreData: any) => {
                //brand data
                result.brand.minVal = Math.min(result.brand.minVal, Number(scoreData?.score));
                result.promo.minVal = Math.min(result.promo.minVal, Number(scoreData?.score));
                result.brand.maxVal = Math.max(result.brand.maxVal, Number(scoreData?.score));
                result.promo.maxVal = Math.max(result.promo.maxVal, Number(scoreData?.score));
                tempBrandData.push({
                    discount: Number(scoreData?.score),
                    category: labelKeyMapping[scoreData?.promoName]?.label || scoreData?.promoName,
                    color: `rgb(${scoreData?.colorsData.R},${scoreData?.colorsData.G},${scoreData?.colorsData.B})`,
                });
            });
            result.brand.data.push(tempBrandData);
        });

        //for promo
        data?.[0]?.questionsData?.scoreData.forEach((scoreData: any, idx: number) => {
            result.promo.label.push(labelKeyMapping[scoreData?.promoName]?.label || scoreData?.promoName);
            let score = 0;
            result.promo.data.push([]);
            data?.forEach((item: any) => {
                // score+=item?.questionsData?.scoreData[idx]?.score||0
                const tempPromoData = {
                    discount: item?.questionsData?.scoreData[idx]?.score || 0,
                    category: item?.attributeType,
                    color: `rgb(${item?.questionsData?.scoreData[idx]?.colorsData.R},${item?.questionsData?.scoreData[idx]?.colorsData.G},${item?.questionsData?.scoreData[idx]?.colorsData.B})`,
                };
                result.promo.data[idx].push(tempPromoData);
            });
        });
        return result;
    } catch (error) {
        console.log(error, 'logging error');
        throw error;
    }
};
